export default "__VITE_ASSET__Bg6hMUlX__"